const Form095TC = {
    stepName: {
        importantNotes: "重要提示",
        applicationInformation: "申請資料",
        confirmation: "確認",
    },

    mainTitle: {
        title: "重要提示",
        picTitle: "個人資料收集聲明",
    },

    importantNotesContent: {
        p1_1: "請在填寫此表格前先閱讀載於以下的個人資料收集聲明。申請人必須提供有關資料。如提供的資料不足，則可能導致款項延遲發放。",
        p1_b1: "如提款申請書",
        p1_u: "填報正確",
        p1_b2: "，則公積金組可於接獲申請書後或由申請人受僱的最後日期起計(以較遲者為準)的二十三個工作天(如在八月至九月期間則為二十八個工作天)內發放公積金款項。",

        p2_1: "為了保障你的權益，請在填寫此表格前先閱讀《津貼學校公積金規則》(第279D 章) 第九及十三條，特別是第十三(2A)",
        p2_i: "(b)",
        p2_2: "條。有關規則，可瀏覽律政司網頁",
        p2_link: "http://www.elegislation.gov.hk",
        p2_3: "。",

        p3: "倘提款申請書之日期較第九段所述者為早，則提款申請書之日期將會被視作戶口終結之日期。",
        p4: "申請人如欲作任何更改，則須由其刪去所需要更改的地方，並在該處加以簽署。其後申請書填報的資料如有改變，申請人須立即書面通知公積金組。",

        p5_1: "申請人須將本申請書交回其所屬學校。申請書經校長/校監證明後，必須由所屬學校交回",
        p5_bu: "香港灣仔皇后大道東213號胡忠大廈15樓1517室",
        p5_2: "教育局公積金組。",

        p6_1: "公積金組會在接獲申請書後十四個工作天內向申請人及其所屬學校發出認收信。如申請人在十四個工作天內沒有收到該信，應致電",
        p6_b1: "2892 6222",
        p6_b2: "2892 5780",
        p6_2: "向公積金組查詢。",

        p7: "如供款人要求以外幣匯款方式退款，可從以下十種貨幣選擇其中一種：澳大利亞元、加拿大元、歐羅、日元、紐西蘭元、新加坡元、瑞士法郎、泰銖、英鎊和美元。",
    },

    iamStatement:
        "為了處理本申請，本人明白 (i) 申請人需要擁有“iAM Smart+”賬戶，以及 (ii) 申請人需要向學校的審批部門確認他們擁有“iAM Smart+”賬戶。",

    note: {
        note1: {
            title: `1.	你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：`,
            subtitle: "收集個人資料的目的",
            content1: "(a)	處理、核實及查證就津貼學校公積金提款的申請；",
            content2:
                "(b)	就上文(a)項所述申請的處理、核實及查證，將個人資料與政府相關政策局／部門資料庫進行核對；",
            content3:
                "(c)	將個人資料與教育局資料庫進行核對，以核實／更新教育局的記錄；",
            content4:
                "(d)	培訓及發展，包括發出計劃／活動邀請、處理發還課程費用申請、評審提名、獎項和獎學金，以及監察達標進度；",
            content5:
                "(e)	處理及審核撥款／補助／津貼申請、發放撥款／補助／津貼，以及審計；",
            content6: "(f)	編製統計資料、研究及政府刊物；以及",
            content7:
                "(g)    執行規則及規例[包括《教育條例》(香港法例第279章)及其附屬法例(例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》)和《資助則例》)]。",
        },
        note2: {
            title: `2.	你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理申請。`,
        },
        note3: {
            title: `3.	你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：`,
            subtitle: "可獲轉移資料者",
            content1:
                "(a)	政府其他政策局及部門，包括庫務署，以用於上文第1段所述的用途；",
            content2: "(b)	與本表格相關的學校，以用於上文第1段所述的用途；",
            content3:
                "(c)	受聘於教育局以提供服務或意見的人員、代理人、服務供應商或機構，以用於上文第1段所述的用途；",
            content4: "(d)	你曾就披露個人資料給予訂明同意；以及",
            content5:
                "(e)	根據適用於香港的法例或法庭命令授權或規定披露個人資料。",
        },
        note4: {
            title: `4.	你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向以下人士提出：`,
            subtitle: "查閱個人資料",
        },
    },

    address: {
        address1: "一級會計主任 (公積金)2",
        address2: "教育局公積金組",
        address3: "香港灣仔皇后大道東213號胡忠大廈15 樓1517室",
        address4: "",
    },

    applicationInformationContent: {
        label: {
            //form 095
            formTitle: "個人資料",

            nameOfContributorEN: "供款人英文姓名 (請依照香港身份證)",
            nameOfContributorCH: "供款人中文姓名 (請依照香港身份證)",

            hkid: "香港身份證號碼",
            dateOfBirth: "出生日期",
            addressEN: "英文住址",
            telNo: "電話",
            staffNo: "員工檔號",

            lastSchoolEmployment: "最後任職之學校",
            primaryOrSecondaryOption: {
                primary: "小學",
                secondary: "中學",
            },
            schoolOption: {
                schoolA: "學校甲",
                schoolB: "學校乙",
                schoolC: "學校丙",
            },
            schoolName: "學校名稱",

            schoolCode: "學校編號",
            lastEmploymentDate: "最後任職之日期",
            lastAccountKeptOpen:
                "已批准公積金戶口保留之最後日期(適用者方可填寫)",

            terminationReason: "停止任職原因",
            terminationReasonOption: {
                resignation: "辭職",
                retirement: "退休",
                dismissal: "撤職",
                death: "死亡",
                illHealth: "健康不佳 (規則第十三(1)(b)條適用)",
                others: "其他",
            },
            pleaseState: "請說明",

            paymentOfProvident: "付款方法",
            paymentOfProvidentOption: {
                byBank: "存入下開本人名下之銀行港幣來往或儲蓄戶口，而一切入帳由銀行認收即可，不必由本人親自領取。本人會負責因填報銀行戶口帳號不正確而需繳付的任何銀行服務收費，並同意由本人之公積金利益扣除。",

                byCheque:
                    "以電匯方式支付予本人於下開香港特別行政區以外的銀行戶口，所需手續費由本人之公積金利益扣除。(請參照申請需知註釋(七)及列明其中一種指定貨幣)",
            },

            // label of by bank
            bankCode: "銀行代碼",
            branchCode: "分行代碼",
            accountNo: "帳號",
            bankName: "銀行名稱",

            // label of by cheque
            overseaAddressOrBankAccount: "銀行名稱/帳號",
            currency: "貨幣",

            // for signing
            signingDeclare:
                "本人已閱畢載於附錄 2013 年教育(修訂)條例並明白修訂條例旨在保障破產的公積金成員在根據該條例維持的公積金中的收益。",
            signingDeclare1: "本人已閱畢載於",
            appendix: "附錄",
            signingDeclare2:
                " 2013 年教育(修訂)條例並明白修訂條例旨在保障破產的公積金成員在根據該條例維持的公積金中的收益。",
            signing1Declare: "本人已閱畢甲部第十二段和丁部的註釋",
            signing2Declare:
                "茲證明上述第一，二，三，六，七，八及十段所載之資料屬實",

            sign1Name: "申請人姓名",
            sign1Date: "日期",

            sign2Name: "姓名",
            sign2Post: "職位",
            sign2PostOption: {
                schoolHead: "校長",
                supervisor: "校監",
            },
            sign2Date: "日期",

            //school chop
            schoolChop: "學校印章",
        },

        errorMsg: {
            // test field unit
            nameOfApplicationEn: "申請人姓名（英文）",
            nameOfApplicationCh: "申請人姓名（中文）",
            nameEN: "英文姓名",
            nameCH: "中文姓名",
            name: "申請人姓名",

            addressEN: "英文住址",
            accountNo: "帳號",

            // specific test message
            telNo: "電話號碼必須為8位數字",
            staffNo: "員工檔號必須為8位數字",
            schoolCode: "學校編號必須為4位數字",
            bankCode: "銀行代碼必須為3位數字",
            threeMonth: "此日期必須在今日後的三個月內",
            afterLastEmploymentDate: "此日期必須在最後任職日期之後",
            atMostOneOption: "此選項只能選擇一項",
        },
    },
};

export default Form095TC;
